import type { SVGProps } from 'react'

type IconName =
  | 'archive'
  | 'attachment'
  | 'chevronLeft'
  | 'chevronRight'
  | 'close'
  | 'edit'
  | 'inbox'
  | 'mail'
  | 'menu'
  | 'message'
  | 'plus'
  | 'reply'
  | 'send'
  | 'settings'
  | 'star'
  | 'trash'

const paths: Record<IconName, string[]> = {
  archive: ['M3 7h18', 'M5 7l1.2 12h11.6L19 7', 'M8 4h8l1.5 3h-11L8 4z', 'M9 11h6'],
  attachment: ['M8 13l6.7-6.7a3 3 0 014.2 4.2l-8.3 8.3a5 5 0 01-7.1-7.1l8-8a3.8 3.8 0 015.4 5.4L9.1 17a2.1 2.1 0 01-3-3l7.4-7.4'],
  chevronLeft: ['M15 18l-6-6 6-6'],
  chevronRight: ['M9 18l6-6-6-6'],
  close: ['M6 6l12 12', 'M18 6L6 18'],
  edit: ['M4 20h4l11-11a2.8 2.8 0 00-4-4L4 16v4z', 'M13.5 6.5l4 4'],
  inbox: ['M4 5h16l-2 10h-4a2 2 0 01-4 0H6L4 5z', 'M4 15v4h16v-4'],
  mail: ['M4 6h16v12H4z', 'M4 7l8 6 8-6'],
  menu: ['M4 7h16', 'M4 12h16', 'M4 17h16'],
  message: ['M5 6h14v10H8l-3 3V6z'],
  plus: ['M12 5v14', 'M5 12h14'],
  reply: ['M10 8l-5 4 5 4', 'M5 12h9a5 5 0 015 5v1'],
  send: ['M3 11.5L21 4l-7.5 18-2.7-7.3L3 11.5z', 'M10.8 14.7L21 4'],
  settings: ['M12 15.5a3.5 3.5 0 100-7 3.5 3.5 0 000 7z', 'M19.4 15a1.7 1.7 0 00.3 1.9l.1.1-2.1 2.1-.1-.1a1.7 1.7 0 00-1.9-.3 1.7 1.7 0 00-1 1.6v.2h-3v-.2a1.7 1.7 0 00-1-1.6 1.7 1.7 0 00-1.9.3l-.1.1L6.6 17l.1-.1A1.7 1.7 0 007 15a1.7 1.7 0 00-1.6-1H5v-3h.4A1.7 1.7 0 007 10a1.7 1.7 0 00-.3-1.9L6.6 8l2.1-2.1.1.1a1.7 1.7 0 001.9.3 1.7 1.7 0 001-1.6v-.2h3v.2a1.7 1.7 0 001 1.6 1.7 1.7 0 001.9-.3l.1-.1L19.8 8l-.1.1a1.7 1.7 0 00-.3 1.9 1.7 1.7 0 001.6 1h.2v3H21a1.7 1.7 0 00-1.6 1z'],
  star: ['M12 4l2.4 5 5.6.8-4 3.9.9 5.6L12 16.6 7.1 19.3l.9-5.6-4-3.9 5.6-.8L12 4z'],
  trash: ['M5 7h14', 'M9 7V5h6v2', 'M8 7l1 13h6l1-13'],
}

export function MailboxIcon({ name, className = '', ...props }: { name: IconName } & SVGProps<SVGSVGElement>) {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className || 'h-4 w-4'}
      {...props}
    >
      {paths[name].map((d, index) => <path key={index} d={d} />)}
    </svg>
  )
}
